import { Router } from '@angular/router';
import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { BrowserAuthError } from "@azure/msal-browser";
import { utilities } from "src/utils/utilities";

@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["login.component.scss"],
})
export class LoginComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
     this.authService.login()
      .subscribe(() => {
      },
        (err: BrowserAuthError) => {
          console.error(err);
          if (err.errorCode === "interaction_in_progress") {
            this.authService.logout()
              .subscribe(() => {
                this.authService.cleanUpMsalCookies();
                this.cleanUpSession();
                this.router.navigateByUrl("/");
              });
          }
        });
  }  

  private cleanUpSession() {
    sessionStorage.clear();
  }
}
